import React from 'react';
import { Box, Typography } from '@mui/material';
import { PVHoverNavy } from '@pv/common/colors';
import { useAuth } from '../../contexts/AuthContext';

export const ConfirmEmailBanner = () => {
  const { guest } = useAuth();
  const currentEmail = guest?.email;

  return (
    <Box
      sx={{
        backgroundColor: PVHoverNavy,
        boxShadow: 'none',
        border: '1px solid #E5E8EB',
        borderRadius: '16px',
        padding: '16px',
      }}
    >
      <Typography variant="body1" fontWeight={400}>
        Please confirm{' '}
        {currentEmail
          ? `your email address (${currentEmail}) `
          : 'your email address '}
        to access invitations.
      </Typography>
    </Box>
  );
};
